import { MuiChip } from '@/components/chip/MuiChip';
import { Box, SxProps } from '@mui/material';
import CanRequestSvg from './CanRequest.svg';
import { CustomPalettes } from '@/themes';

type Props = {
  sxProps?: SxProps;
};

export function CanRequestLabel({ sxProps }: Props) {
  return (
    <MuiChip
      label={`紹介可能`}
      icon={
        <Box
          component="img"
          src={CanRequestSvg.src}
          sx={{
            margin: '0px',
            width: `45px`,
          }}
        />
      }
      sx={{
        backgroundColor: CustomPalettes['Space/pallet/Accent/100'],
        borderRadius: '4px',
        typography: 'JP/Body/m/Medium/None',
        padding: '0px 4px',
        height: '30px',
        '& .MuiChip-label': {
          marginBottom: '2px',
          paddingRight: '8px',
        },
        ...sxProps,
      }}
    />
  );
}
